export const initMap = (mapNode, ymapsObjectManager, id, center, zoom) => {
	/**
	 * Get bounds from markers set
	 * **/
	const coordinates = ymapsObjectManager.objects.getAll().map((markerData) => markerData.geometry.coordinates);
	const bounds = ymaps.util.bounds.fromPoints(coordinates);
	const mapProperties = ymaps.util.bounds.getCenterAndZoom(bounds, [mapNode.offsetWidth, mapNode.offsetHeight]);
	/** **/
	
	const ymapsMap = new ymaps.Map( id, {
		center: center[0] || center[1] ? center : mapProperties.center,
		zoom: zoom ? zoom : mapProperties.zoom,
		controls: [],
	}, {
		yandexMapDisablePoiInteractivity: true,
		suppressMapOpenBlock: true
	});

	ymapsMap.controls.add(new ymaps.control.ZoomControl({options: {size: `small`, position: {top:`auto`,bottom:`24px`,right:`24px`,left:`auto`}}}));
	ymapsMap.behaviors.disable( `scrollZoom` );
	
	return ymapsMap;
};
